import { createContext, useContext, useMemo } from 'react';

const FiltersContext = createContext();

export const FiltersProvider = ({
  children,
  filters,
  config,
  resetFilters,
  locationInputRef,
  handleUpdateOnline,
}) => {
  const value = useMemo(
    () => ({
      filters,
      config,
      resetFilters,
      locationInputRef,
      handleUpdateOnline,
    }),
    [filters, config, resetFilters, locationInputRef, handleUpdateOnline],
  );

  return (
    <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
  );
};

export const useFiltersContext = () => useContext(FiltersContext);

export const withFiltersContext = (Component) => (props) => {
  const contextValue = useFiltersContext();

  return <Component {...contextValue} {...props} />;
};

export default FiltersContext;
